
import Box from '@mui/material/Box';
import EDTypography from '../Typography/EDTypography';
import { IRapportCheckBoxControl } from './RapportMallTypes';
import {
  AVENY_REPORT_CHECKBOX_HEIGHT,
  SELECTED_SHADOW,
  getPositionStyle,
} from './RapportMallUtils';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';
import { RapportKontrollHeader } from './RapportKontrollHeader';

export interface IProps {
  ctrl: IRapportCheckBoxControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportCheckBoxControl) => void;
  controlPath: number[];
  selected?: boolean;
  inCondition?: boolean;
  maxWidth: number;
}

export const RapportCheckBox: React.FC<IProps> = props => {
  const { ctrl, sx, onMouseEnter, onMouseLeave, selected, maxWidth } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        background: 'white',
        boxShadow: selected ? SELECTED_SHADOW : 'none',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          AVENY_REPORT_CHECKBOX_HEIGHT
        ),
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      <Box
        component="input"
        sx={{
          width: 18,
          height: 18,
          minWidth: 18,
          minHeight: 18,
          maxWidth: 18,
          maxHeight: 18,
          margin: 0,
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          border: '1px solid #888',
          borderRadius: 0,
          outline: 'none',
          cursor: 'pointer',
          backgroundColor: props.inCondition ? 'lightYellow' : '#f1f4ff',
          position: 'relative',
        }}
        type="checkbox"
        checked={!!ctrl.Checked}
        readOnly
      />
      {ctrl.Checked && (
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: 18,
            height: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 8.5L7 13L13 3"
              stroke="black"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Box>
      )}
      <EDTypography variant="body2">{ctrl.Caption}</EDTypography>
    </Box>
  );
};

export interface IRapportCheckBoxEditProps {
  value: IRapportCheckBoxControl;
  onChange: (ctrl: IRapportCheckBoxControl) => void;
}

export const RapportCheckBoxEdit: React.FC<
  IRapportCheckBoxEditProps
> = props => (
  <Box sx={{ mt: 2 }}>
    <Box sx={{ mb: 3 }}>
      <RapportKontrollHeader value={props.value} />
      <TextField
        label="Namn"
        value={props.value.Name}
        onChange={e => props.onChange({ ...props.value, Name: e.target.value })}
        fullWidth
        size="small"
        sx={{ mb: 2 }}
      />
      <RapporteditorTextField
        label="Rubrik"
        field="Caption"
        value={props.value}
        onChange={props.onChange}
        allowModelSelect
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={!!props.value.Checked}
            onChange={e =>
              props.onChange({ ...props.value, Checked: e.target.checked })
            }
          />
        }
        label="Förvald"
        sx={{ mb: 2 }}
      />
    </Box>
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
